import { Breadcrumb, COLLECTING_BREADCRUMB } from "@/components/PageHeader/PageHeaderNew";

export const PACKAGING_BREADCRUMBS: Breadcrumb[] = [
  COLLECTING_BREADCRUMB,
  {
    label: "Product packaging",
    url: "/packaging",
  },
];
